import { createSlice } from "@reduxjs/toolkit";
import { readGamificationBlob, restoreGamificationBlob } from "./gamificationService";

const token = localStorage.getItem("token");

const initialState = {
  token: token || null,
  isLoggedIn: !!token,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.token = action.payload;
      state.isLoggedIn = true;
      localStorage.setItem("token", action.payload);
    },
    logout: (state) => {
      state.token = null;
      state.isLoggedIn = false;
      const coinBlob = readGamificationBlob();
      localStorage.removeItem("token");
      sessionStorage.removeItem("token");
      localStorage.removeItem("userData");
      sessionStorage.removeItem("userData");
      sessionStorage.removeItem("activeProfileContext");
      localStorage.clear();
      sessionStorage.clear();
      restoreGamificationBlob(coinBlob);
      // Redirect will be handled in component using useNavigate
    },
  },
});

export const { loginSuccess, logout } = authSlice.actions;
export default authSlice.reducer;
